// extracted by mini-css-extract-plugin
export default {"field":"FaqModal_field__wLv7z","hint":"FaqModal_hint__F+BuM"};